module.exports = __webpack_public_path__ + "img/TopLiga-Footer.6bbee54c.svg";